import React, { FC, Fragment, useState } from 'react';
import { Box, Button, Grid, Theme, useMediaQuery } from '@mui/material';
import { UserListFilter } from 'models/user';
import { useTranslation } from 'react-i18next';
import FreeTextFilterComponent from 'components/users/shared/free-text-filter/free-text-filter.component';
import FilterOnStatusDropdown from 'components/users/shared/filter-on-status-dropdown/filter-on-status-dropdown.component';
import RoleFilter from 'components/users/shared/role-filter/role-filter.component';
import AddIcon from '@mui/icons-material/Add';

type DentistPageActionsProps = {
    onFilterChange: ({ freeText, active, role }: UserListFilter) => void;
    onAddUserDialogOpen?: () => void;
};

const DentistPageActions: FC<DentistPageActionsProps> = ({
    onFilterChange,
    onAddUserDialogOpen,
}: DentistPageActionsProps) => {
    const { t: translate } = useTranslation(['users']);
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
    const [filter, setFilter] = useState<UserListFilter>({
        freeText: '',
        active: true,
        role: '',
    });

    const handleFilterChange = (freeTextInput: string) => {
        setFilter({
            freeText: freeTextInput,
            active: filter.active,
            role: filter.role,
        });
        onFilterChange({
            freeText: freeTextInput,
            active: filter.active,
            role: filter.role,
        });
    };

    const handleStatusSelected = (active: boolean | null) => {
        setFilter({
            freeText: filter.freeText,
            active: active,
            role: filter.role,
        });
        onFilterChange({
            freeText: filter.freeText,
            active: active,
            role: filter.role,
        });
    };

    const handleRoleSelected = (role: string) => {
        setFilter({
            freeText: filter.freeText,
            active: filter.active,
            role: role,
        });
        onFilterChange({
            freeText: filter.freeText,
            active: filter.active,
            role: role,
        });
    };

    return (
        <Fragment>
            <Box mb={1} display="flex" alignItems="center" flexDirection={!isMobile ? 'row' : 'column-reverse'}>
                <Grid container spacing={1}>
                    <Grid item md={4} xs={12}>
                        <FreeTextFilterComponent
                            value={filter.freeText}
                            freeTextFilterChange={handleFilterChange}
                            label="Filter name"
                        />
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <FilterOnStatusDropdown fullWidth statusSelected={handleStatusSelected} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <RoleFilter fullWidth roleSelected={handleRoleSelected} />
                    </Grid>
                </Grid>
                {onAddUserDialogOpen ? (
                    <Box flex="1 0 auto">
                        <Button fullWidth variant="contained" onClick={onAddUserDialogOpen} startIcon={<AddIcon />}>
                            {translate('users:ADD_DENTIST')}
                        </Button>
                    </Box>
                ) : undefined}
            </Box>
        </Fragment>
    );
};

export default DentistPageActions;
